export default function Gallery() {
  const images = [
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/749fd241c65b421abd245331b26effbc.png',
      title: 'Chicago Nights',
    },
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/94371b03d6a6ff1af529c411f330c9aa.png',
      title: 'Studio Sessions',
    },
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/748f2d39088f3cdf92afda5a963a9f38.png',
      title: 'Visual Art',
    },
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/ce007e3025c316cef2cde769774d304c.png',
      title: 'Live Energy',
    },
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/e97ad9b4600ec1a111df878496cd9c43.png',
      title: 'The Lifestyle',
    },
    {
      url: 'https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/23a583cdc4564ad3654fadad8f7619c7.png',
      title: 'Creative Process',
    },
  ];

  return (
    <section className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black mb-4 text-white">
            THE JOURNEY
          </h2>
          <p className="text-xl text-gray-400">
            Every frame intentional, every emotion curated
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative group overflow-hidden aspect-square cursor-pointer"
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-red-600 transition-colors duration-300"></div>
            </div>
          ))}
        </div>

        {/* Social Links */}
        <div className="mt-20 text-center">
          <p className="text-gray-500 mb-6 uppercase tracking-wider text-sm">Follow The Journey</p>
          <div className="flex justify-center gap-6">
            <a href="#" className="w-14 h-14 flex items-center justify-center bg-zinc-900 border-2 border-zinc-800 hover:border-red-600 hover:bg-red-600 transition-all duration-300 cursor-pointer">
              <i className="ri-instagram-fill text-2xl text-white"></i>
            </a>
            <a href="#" className="w-14 h-14 flex items-center justify-center bg-zinc-900 border-2 border-zinc-800 hover:border-red-600 hover:bg-red-600 transition-all duration-300 cursor-pointer">
              <i className="ri-twitter-x-fill text-2xl text-white"></i>
            </a>
            <a href="#" className="w-14 h-14 flex items-center justify-center bg-zinc-900 border-2 border-zinc-800 hover:border-red-600 hover:bg-red-600 transition-all duration-300 cursor-pointer">
              <i className="ri-tiktok-fill text-2xl text-white"></i>
            </a>
            <a href="#" className="w-14 h-14 flex items-center justify-center bg-zinc-900 border-2 border-zinc-800 hover:border-red-600 hover:bg-red-600 transition-all duration-300 cursor-pointer">
              <i className="ri-youtube-fill text-2xl text-white"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
